module.exports = __webpack_public_path__ + "static/preview-img5@2x-e2800bfd6c6b9af0ae634b15175dd4e5.png";